// Horse profile completeness card. Mirrors
// data-component="horse-profile-completeness" from the approved HTML.
// Lists the missing fields with a + button each; clicking opens the
// matching editor.
//
// Per project memory: keep "not discussed", "unknown" and "declined"
// distinct. The footer small text repeats this rule so reps don't
// flatten the three states into one.
//
// TODO(runtime): hydrate missing-field list from services/horse-timeline
// completeness check (proposed - TODO runtime). Each entry routes to its
// own editor mode.
import type { ReactNode } from 'react';
import type { HorseProfile, EditorMode } from '../mockData.js';

export interface HorseProfileCompletenessProps {
  horse: HorseProfile;
  onEdit: (mode: EditorMode) => void;
}

const KEY_TO_EDITOR: Record<string, EditorMode> = {
  birth: 'profile',
  dose: 'routine',
  goal: 'goals',
};

export function HorseProfileCompleteness({
  horse,
  onEdit,
}: HorseProfileCompletenessProps): ReactNode {
  return (
    <section className="card" data-component="horse-profile-completeness">
      <div className="section-heading">
        <h3>Complete {horse.name}'s picture</h3>
        <span className="needs-pill">To confirm</span>
      </div>
      <div className="missing-list">
        {horse.completeness.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onEdit(KEY_TO_EDITOR[item.key] ?? 'profile')}
          >
            <span>{item.label}</span>
            <b>+</b>
          </button>
        ))}
      </div>
      <p className="horse-small">Keep "not discussed," "unknown" and "declined" distinct.</p>
    </section>
  );
}
